(function () {
  'use strict';

  // ═════════════════════════════════════════════════════
  // Quantity selector (buy box)
  // ═════════════════════════════════════════════════════
  function bindQty(root) {
    root.querySelectorAll('.pz-product-buy__qty').forEach((wrap) => {
      if (wrap.__pzQtyBound) return;
      wrap.__pzQtyBound = true;
      const input = wrap.querySelector('[data-qty-input]');
      const minus = wrap.querySelector('[data-qty="minus"]');
      const plus = wrap.querySelector('[data-qty="plus"]');
      if (!input) return;
      const step = () => Math.max(1, parseInt(input.step, 10) || 1);
      const min = () => Math.max(1, parseInt(input.min, 10) || 1);
      const clamp = (v) => {
        const n = parseInt(v, 10);
        if (!Number.isFinite(n)) return min();
        return Math.max(min(), n);
      };
      if (minus) {
        minus.addEventListener('click', () => {
          input.value = clamp((parseInt(input.value, 10) || 1) - step());
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      if (plus) {
        plus.addEventListener('click', () => {
          input.value = clamp((parseInt(input.value, 10) || 1) + step());
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      input.addEventListener('change', () => {
        input.value = clamp(input.value);
      });
    });
  }

  // ═════════════════════════════════════════════════════
  // Accordion smooth open/close (based on <details> native)
  // — respects prefers-reduced-motion
  // ═════════════════════════════════════════════════════
  function bindAccordion(root) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    root.querySelectorAll('details[data-pz-accordion]').forEach((d) => {
      if (d.__pzAccBound) return;
      d.__pzAccBound = true;
      const summary = d.querySelector('summary');
      const body = d.querySelector('.pz-accordion__body');
      if (!summary || !body) return;

      let animating = false;

      summary.addEventListener('click', (e) => {
        if (animating) { e.preventDefault(); return; }
        e.preventDefault();
        animating = true;

        if (d.open) {
          // Close
          const startH = body.scrollHeight;
          body.style.overflow = 'hidden';
          body.style.height = startH + 'px';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              body.style.transition = 'height 220ms ease';
              body.style.height = '0px';
            });
          });
          body.addEventListener('transitionend', function onEnd() {
            body.removeEventListener('transitionend', onEnd);
            body.style.transition = '';
            body.style.height = '';
            body.style.overflow = '';
            d.open = false;
            animating = false;
          }, { once: true });
        } else {
          // Open
          d.open = true;
          const endH = body.scrollHeight;
          body.style.overflow = 'hidden';
          body.style.height = '0px';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              body.style.transition = 'height 240ms ease';
              body.style.height = endH + 'px';
            });
          });
          body.addEventListener('transitionend', function onEnd() {
            body.removeEventListener('transitionend', onEnd);
            body.style.transition = '';
            body.style.height = '';
            body.style.overflow = '';
            animating = false;
          }, { once: true });
        }
      });
    });
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    bindQty(root);
    bindAccordion(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Shopify section re-render
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
